import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { GitHubUserToken } from './GitHubUserTokenExtension';

export const gitHubUserTokenField = {
  name: 'GitHubUserToken',
  component: GitHubUserToken,
};

export const GitHubUserTokenExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension(gitHubUserTokenField),
);
